// @flow
import React, { Component } from 'react';
import { Field } from 'redux-form';
import {
  AccountInformationDiv,
  TitleH3,
  SectionWrapperDiv,
  Section,
  BankAccountInput,
  BankAccountDropdownInput
} from './BankAccountStyles';
import { requiredField } from '../../../utilities/validations';
import { type Currency } from '../../../utilities/types';

type Props = {
  editable: boolean,
  fiatCurrencies: Currency[]
};

export default class AccountInformation extends Component<Props> {
  render() {
    const currencyOptions = this.props.fiatCurrencies.map(currency => ({
      value: currency.id,
      text: currency.iso4217
    }));
    currencyOptions.unshift({ value: '', text: '' });
    return (
      <AccountInformationDiv>
        <TitleH3>Bank Account Information</TitleH3>
        <SectionWrapperDiv>
          <Section>
            <Field
              name="bank_name"
              label="Bank Name"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="bank_address"
              label="Bank Address"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="bank_zip"
              label="Zip/Postal Code"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="bank_state"
              label="State / Province"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="bank_country"
              label="Country"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
          </Section>
          <Section right>
            <Field
              name="currency_id"
              label="Currency"
              component={BankAccountDropdownInput}
              options={currencyOptions}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="institution_number"
              label="Institution Number"
              component={BankAccountInput}
              readOnly={this.props.editable}
            />
            <Field
              name="branch_number"
              label="Branch / Transit Number"
              component={BankAccountInput}
              readOnly={this.props.editable}
            />
            <Field
              name="account_number"
              label="Account Number"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
              secure={this.props.editable}
            />
            <Field
              name="swift_code"
              label="Swift Code"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
          </Section>
        </SectionWrapperDiv>
      </AccountInformationDiv>
    );
  }
}
